import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFour = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M11.686 18.68V16.748L16.11 10.42H18.784V16.608H19.932V18.68H18.784V20.5H16.39V18.68H11.686ZM16.558 13.052L14.206 16.608H16.558V13.052Z" })
});
export { SvgFour as ReactComponent };
